import { errorToastMessage, successToastMessage } from "utils/errorToast";
import {
  GSTIN_LIST,
  LOADER_STATUS,
  SELECTED_GSTIN,
  SELECTED_DATE,
  NOTICE_TABLE_DATA,
  TOTAL_PAGES,
  TOTAL_PAGES_HISTORY,
  SCHEDULER_TABLE_DATA,
  SEARCH,
  HISTORY_DATA,
  ENTITY_LIST,
  SELECTED_ENTITY,
  PROFILE_DATA,
  REF_IDS_LIST,
  NOTICE_TYPE_LIST,
  SELECTED,
  SELECTED_ROW,
  SELECTED_FROM_PERIOD,
  SELECTED_TO_PERIOD,
  SELECTED_ISSUE_DATE,
  SELECTED_DUE_DATE,
  NOTICE_TYPE_CODE_FILTER_LIST,
  REFERENCE_ID_FILTER_LIST,
} from "./constants";
import { getLocalStorage } from "components/Helper/Helper.js";
import { Config } from "../../../Config.js";
import axios from "axios";
import { convertDateFormat } from "../Utility/utilis";
import moment from "moment";

export function loader(status) {
  return {
    type: LOADER_STATUS,
    loaderStatus: status,
  };
}

export function setGstinList(data) {
  return {
    type: GSTIN_LIST,
    gstinList: data,
  };
}

export function setSelectedGstin(gstin) {
  return {
    type: SELECTED_GSTIN,
    selectedGstin: gstin,
  };
}

export function setSelectedDate(date) {
  return {
    type: SELECTED_DATE,
    selectedDate: date,
  };
}

export function setNoticeTableData(data) {
  return {
    type: NOTICE_TABLE_DATA,
    noticeTableData: data,
  };
}

export function setTotalPages(pages) {
  return {
    type: TOTAL_PAGES,
    totalPages: pages,
  };
}

export function setTotalPagesHistory(pages) {
  return {
    type: TOTAL_PAGES_HISTORY,
    totalPagesHistory: pages,
  };
}

export function setSchedulerTableData(data) {
  return {
    type: SCHEDULER_TABLE_DATA,
    schedulerTableData: data,
  };
}

export function setSearch(searchTerm) {
  return {
    type: SEARCH,
    search: searchTerm,
  };
}

export function setHistoryData(data) {
  return {
    type: HISTORY_DATA,
    historyData: data,
  };
}

export function setEntityList(data) {
  return {
    type: ENTITY_LIST,
    entityList: data,
  };
}

export function setSelectedEntity(entity) {
  return {
    type: SELECTED_ENTITY,
    selectedEntity: entity,
  };
}

export function setProfileData(data) {
  return {
    type: PROFILE_DATA,
    profileData: data,
  };
}

export function setRefIdsList(data) {
  return {
    type: REF_IDS_LIST,
    refIdsList: data,
  };
}

export function setNoticeTypeList(data) {
  return {
    type: NOTICE_TYPE_LIST,
    noticeTypeList: data,
  };
}

export function setSelected(data) {
  return {
    type: SELECTED,
    selected: data,
  };
}

export function setSelectedRow(data) {
  return {
    type: SELECTED_ROW,
    selectedRow: data,
  };
}

export function setSelectedFromPeriod(data) {
  return {
    type: SELECTED_FROM_PERIOD,
    selectedFromPeriod: data,
  };
}

export function setSelectedToPeriod(data) {
  return {
    type: SELECTED_TO_PERIOD,
    selectedToPeriod: data,
  };
}

export function setSelectedIssueDate(data) {
  return {
    type: SELECTED_ISSUE_DATE,
    selectedIssueDate: data,
  };
}

export function setSelectedDueDate(data) {
  return {
    type: SELECTED_DUE_DATE,
    selectedDueDate: data,
  };
}

export function setNoticeTypeCodeFilterList(data) {
  return {
    type: NOTICE_TYPE_CODE_FILTER_LIST,
    noticeTypeCodeFilterList: data,
  };
}

export function setReferenceIdFilterList(data) {
  return {
    type: REFERENCE_ID_FILTER_LIST,
    referenceIdFilterList: data,
  };
}

export const getGstinList = () => {
  return async (dispatch) => {
    dispatch(loader(true));

    try {
      const response = await axios({
        method: "post",
        url: `${Config.url}gst/get_profile`,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      });

      console.log("response ", response);

      if (response.data.error === 0) {
        const gstinArray =
          response.data?.profileInfo?.map((profile) => profile.gstin) || [];
        const uniqueGstinArray = [...new Set(gstinArray)].sort((a, b) =>
          a > b ? 1 : -1
        );
        dispatch(setGstinList(uniqueGstinArray));
        console.log("uniqueGstinArray ", uniqueGstinArray);
        // return uniqueGstinArray
      }

      return true;
      
    } catch (error) {
      console.log("Error in getProfile:", error);
      errorToastMessage("Failed to fetch profile data");
      return false;
    } finally {
      dispatch(loader(false));
    }
  };
};

export const fetchNoticeData = (gstin, date) => {
  return async (dispatch) => {
    dispatch(loader(true));
    const token = getLocalStorage("loginDetails");

    // Convert date format from YYYY-MM-DD to DD/MM/YYYY
    const formattedDate = convertDateFormat(date);
    console.log(`Date converted from ${date} to ${formattedDate}`);

    try {
      const response = await axios({
        method: "get",
        url: `${Config.url}notices/gov/list`,
        params: {
          gstin: gstin,
          date: formattedDate,
        },
        timeout: 600000,
        headers: { token },
      });

      // Success response
      if (response.data.status === "success" || response.data.status === 200) {
        const noticeData = response.data.data;

        successToastMessage(
          response.data.message ||
            `Successfully fetched ${noticeData.count} notices`
        );
        return true;
      } else {
        errorToastMessage(
          response.data.message || "Error while fetching notice data"
        );
        return false;
      }
    } catch (error) {
      console.log("Error in fetchNoticeData:", error);
      errorToastMessage("Error while fetching notice data");
      return false;
    } finally {
      dispatch(loader(false));
    }
  };
};

export const getNoticeTableData = (filters = {}) => {
  return async (dispatch) => {
    dispatch(loader(true));
    const token = getLocalStorage("loginDetails");

    // Prepare request data
    const requestData = {
      mode: "note",
      page: filters.page || 1,
      pageSize: filters.pageSize || 10,
    };

    // Add optional parameters if provided
    if (filters.gstin) requestData.gstins = filters.gstin;
    if (filters.periodMonth) requestData.periodMonth = filters.periodMonth;
    if (filters.periodFy) requestData.periodFy = filters.periodFy;
    if (filters.status) requestData.status = filters.status;
    if (filters.markStatus) requestData.markStatus = filters.markStatus;
    if (filters.moduleCd) requestData.moduleCd = filters.moduleCd;
    if (filters.alertCd) requestData.alertCd = filters.alertCd;
    if (filters.q) requestData.q = filters.q; // search query
    if( filters.fromPeriod) requestData.fromPeriod = moment(filters.fromPeriod).format("MMM - YYYY").toUpperCase();
    if( filters.toPeriod) requestData.toPeriod = moment(filters.toPeriod).format("MMM - YYYY").toUpperCase();
    if( filters.issueDate) requestData.issueDate = moment(filters.issueDate).format("DD/MM/YYYY");
    if( filters.dueDate) requestData.dueDate = moment(filters.dueDate).format("DD/MM/YYYY");
    if(filters.refId && filters.refId.length>0) requestData.referenceId = filters.refId;
    if(filters.noticeType && filters.noticeType.length>0) requestData.noticeType = filters.noticeType;
    console.log("Notice table request data:", requestData);

    try {
      const response = await axios({
        method: "post",
        url: `${Config.url}notices/detailList`,
        data: requestData,
        timeout: 600000,
        headers: {
          "Content-Type": "application/json",
          token,
        },
      });

      if (response.data?.status === "success" || response.data?.error === 0) {
        console.log("Notice table response data data:", response.data.data.notices);
        const noticeData = response.data.data.notices|| [];
        const totalRecords = response.data.data.pagination?.totalRecords || 0;
        const totalPages = Math.ceil(totalRecords / 10);
        dispatch(setNoticeTableData(noticeData));
        dispatch(setTotalPages(totalPages));
        return;
      } else {
        console.log("No notice data found or request failed");
        errorToastMessage(
          response.data.message || "Failed to fetch notice data"
        );
        return;
      }
    } catch (error) {
      console.log("Error in getNoticeTableData:", error);
      errorToastMessage("Error while getting notice data");
      return { data: [], total: 0, page: 1, pageSize: 10 };
    } finally {
      dispatch(loader(false));
    }
  };
};

export const getSchedularList = (gstin = null,msg=true) => {
  return async (dispatch) => {
    dispatch(loader(true));
    const token = getLocalStorage("loginDetails");

    // Prepare query parameters
    const params = {};
    if (gstin) {
      params.gstin = gstin;
    }

    console.log("Schedular list request params:", params);

    try {
      const response = await axios({
        method: "get",
        url: `${Config.url}notices/schedules`,
        params: params,
        timeout: 600000,
        headers: {
          token,
        },
      });

      // Check for success response
      if (
        response.data.status === "success" &&
        response.data.statusCode === 200
      ) {
        const schedularData = response.data?.data || [];
        dispatch(setSchedulerTableData(schedularData));
      if(msg)  successToastMessage(
          response.data.message ||
            `Successfully fetched ${schedularData.length} schedules`
        );
        return true;
      }

      // Handle API error responses
      else if (response.data.status === "error") {
        console.log("API Error:", response.data);
        console.log(
          `Error Status: ${response.data.status}, Status Code: ${response.data.statusCode}`
        );
      if(msg)  errorToastMessage(response.data.message || "Failed to fetch schedules");
        dispatch(setSchedulerTableData([]));
        return false;
      }

      // Handle other unexpected responses
      else {
        console.log("Unexpected response:", response.data);
       if(msg) errorToastMessage("Unexpected response from server");
        dispatch(setSchedulerTableData([]));

        return false;
      }
    } catch (error) {
      console.log("Error in getSchedularList:", error);
      // Check if error has response data (API error) or is a network/other error
      const errorMessage =
        error?.response?.data?.message || "Error while fetching schedules";
     if(msg) errorToastMessage(errorMessage);
      dispatch(setSchedulerTableData([]));

      return false;
    } finally {
      dispatch(loader(false));
    }
  };
};

export const createSchedule = (scheduleData) => {
  return async (dispatch) => {
    dispatch(loader(true));
    const token = getLocalStorage("loginDetails");

    try {
      const response = await axios({
        method: "post",
        url: `${Config.url}notices/schedule`,
        data: scheduleData,
        timeout: 600000,
        headers: {
          token,
        },
      });

      // Check for success response
      if (
        response.data.status === "success" &&
        response.data.statusCode === 201
      ) {
        successToastMessage(
          response.data.message || "Schedule created successfully"
        );
        return true;
      }

      // Handle API error responses
      else if (response.data.status === "error") {
        console.log("API Error:", response.data);
        console.log(
          `Error Status: ${response.data.status}, Status Code: ${response.data.statusCode}`
        );
        errorToastMessage(response.data.message || "Failed to create schedule");
        return false;
      }

      // Handle other unexpected responses
      else {
        console.log("Unexpected response:", response.data);
        errorToastMessage("Unexpected response from server");
        return false;
      }
    } catch (error) {
      console.log("Error in createSchedule:", error);
      // Check if error has response data (API error) or is a network/other error
      const errorMessage =
        error?.response?.data?.message || "Error while creating schedule";
      errorToastMessage(errorMessage);
      return false;
    } finally {
      dispatch(loader(false));
    }
  };
};

export const getFetchHistory = (toastMsg = false,page) => {
  return async (dispatch) => {
    dispatch(loader(true));
    const token = getLocalStorage("loginDetails");

    try {
      const response = await axios({
        method: "get",
        url: `${Config.url}notices/fetch-history`,
        params: {
          page: page || 1,
          pageSize: 10,
        },
        timeout: 600000,
        headers: {
          "Content-Type": "application/json",
          token,
        },
      });

      // console.log("response.data.data::", response.data.data);
      const data_from_api = response.data.data;
      // console.log('data_from_api.data::',data_from_api.data)
      // Check for success response
      if (data_from_api?.status === "success") {
        const totalRecords = data_from_api?.pagination?.totalRecords || 0;
        const totalPages = Math.ceil(totalRecords / 10);
        dispatch(setHistoryData(data_from_api.data || []));
        dispatch(setTotalPagesHistory(totalPages));
       if(toastMsg) successToastMessage(
          data_from_api.message || "Successfully fetched history data"
        );
        return data_from_api.data;
      } else {
        dispatch(setHistoryData([]));
       if(toastMsg) errorToastMessage(
          data_from_api.message || "Failed to fetch history data"
        );
        return [];
      }
    } catch (error) {
      console.log("Error in getFetchHistory:", error);
      // Check if error has response data (API error) or is a network/other error
      // const errorMessage =
      //   error?.response?.data?.message || "Error while fetching history data";
      // errorToastMessage(errorMessage);
      dispatch(setHistoryData([]));
      return false;
    } finally {
      dispatch(loader(false));
    }
  };
};

export const fetchNoticesBulk = (gstinList, fromDate) => {
  return async (dispatch) => {
    dispatch(loader(true));
    const token = getLocalStorage("loginDetails");

    const requestData = {
      gstins:gstinList,
      date:fromDate,
    };

    console.log("Bulk fetch request data:", requestData);

    try {
      const response = await axios({
        method: "post",
        url: `${Config.url}notices/fetch-bulk`,
        data: requestData,
        timeout: 600000,
        headers: {
          "Content-Type": "application/json",
          token,
        },
      });

      // Check for success response
      if (response.data.status === "success") {
        successToastMessage(
          response.data.message ||
            "Background bulk fetch initiated successfully"
        );
        console.log("Bulk fetch initiated:", response.data.data);
        // Refresh fetch history after successful bulk fetch initiation
        dispatch(getFetchHistory());
        return true;
      }

      // Handle API error responses
      else if (response.data.status === "error") {
        console.log("API Error:", response.data);
        console.log(
          `Error Status: ${response.data.status}, Status Code: ${response.data.statusCode}`
        );
        errorToastMessage(
          response.data.message || "Failed to initiate bulk fetch"
        );
        return false;
      }

      // Handle other unexpected responses
      else {
        console.log("Unexpected response:", response.data);
        errorToastMessage("Unexpected response from server");
        return false;
      }
    } catch (error) {
      console.log("Error in fetchNoticesBulk:", error);
      // Check if error has response data (API error) or is a network/other error
      const errorMessage =
        error?.response?.data?.message || "Error while initiating bulk fetch";
      errorToastMessage(errorMessage);
      return false;
    } finally {
      dispatch(loader(false));
    }
  };
};

export function getEntityList() {
  return (dispatch) => {
    // dispatch(loader(true));
    let data = {
      user_id: getLocalStorage("user_id").user_id,
    };
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}console/getCompanyByUserId`,
        data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      })
        .then((response) => {
          if (response.data.error != 1) {
            let entityList = response.data.data.map((entity) => {
              return { value: entity.company_id, label: entity.name };
            });
            dispatch(setEntityList(entityList));
            resolve(true);
          } else {
            resolve([]);
          }
          // dispatch(loader(false));
        })
        .catch((error) => {
          dispatch(loader(false));
          console.log(error);
          reject(true);
        });
    });
  };
}
export const getGstinByEntity = (entityId) => {
  return async (dispatch) => {
    dispatch(loader(true));
    const token = getLocalStorage("loginDetails");
    const userId = getLocalStorage("user_id").user_id;

    const data = {
      entity_id: entityId,
      user_id: userId,
    };
    const URL_NOTICE = `${Config.url}notices/getGstinNotice`
    try {
      const response = await axios({
        method: "post",
        url: URL_NOTICE,
        // url: `${Config.url}console/getGstnListByEntityId`,
        data: data,
        headers: { token },
      });

      if (response.data.error !== 1) {
        if (response.data?.data?.length > 0) {
          // Remove duplicates based on GSTIN and then sort
          const uniqueData = response.data.data.filter((item, index, array) => 
            array.findIndex(obj => obj.gstin === item.gstin) === index
          );
          
          const sortedGstin = uniqueData.sort((a, b) =>
            a.gstin > b.gstin ? 1 : -1
          );
          dispatch(setProfileData(sortedGstin));

          // Update GSTIN list for dropdown - ensure unique GST numbers
          const gstinArray = sortedGstin.map((profile) => profile.gstin);
          const uniqueGstinArray = [...new Set(gstinArray)].sort((a, b) =>
            a > b ? 1 : -1
          );
          dispatch(setGstinList(uniqueGstinArray));

          return sortedGstin;
        } else {
          dispatch(setProfileData([]));
          dispatch(setGstinList([]));
          return [];
        }
      } else {
        console.log("Error in API response:", response.data);
        errorToastMessage("Failed to fetch GSTIN data");
        dispatch(setProfileData([]));
        dispatch(setGstinList([]));
        return [];
      }
    } catch (error) {
      console.log("Error in getGstinByEntity:", error);
      errorToastMessage("Error while fetching GSTIN data");
      dispatch(setProfileData([]));
      dispatch(setGstinList([]));
      return [];
    } finally {
      dispatch(loader(false));
    }
  };
};

export const fetchFilterList = (gstinList) => {
  return async (dispatch) => {
    dispatch(loader(true));
    const token = getLocalStorage("loginDetails");

    const requestData = {
      gstins: Array.isArray(gstinList) ? gstinList : [gstinList],
    };

    // console.log("Filter list request data:", requestData);

    try {
      const response = await axios({
        method: "post",
        url: `${Config.url}notices/filter-list`,
        data: requestData,
        timeout: 600000,
        headers: {
          "Content-Type": "application/json",
          token,
        },
      });

      console.log("Filter list response data:", response.data.data);
      // Check for success response
      if (response.data.status === "success") {
        const data_from_api = response.data.data || [];
        dispatch(setRefIdsList(data_from_api?.referenceIdList || []));
        dispatch(setNoticeTypeList(data_from_api?.noticeTypesList || []));
        return true;
      }

      // Handle API error responses
      else if (response.data.status === "error") {
        dispatch(setRefIdsList([]));
        return false;
      }

      // Handle other unexpected responses
      else {
        console.log("Unexpected response:", response.data);
        errorToastMessage("Unexpected response from server");
        return false;
      }
    } catch (error) {
      console.log("Error in fetchFilterList:", error);
      // Check if error has response data (API error) or is a network/other error
      const errorMessage =
        error?.response?.data?.message || "Error while fetching filter list";
      errorToastMessage(errorMessage);
      return false;
    } finally {
      dispatch(loader(false));
    }
  };
};

const getFileName = (docType) => {
  switch (docType) {
    case "maindocs":
      return "main_documents.zip";
    case "suppdocs":
      return "supporting_documents.zip";
    case "all":
      return "all_documents.zip";
    default:
      return "documents.zip";
  }
};

export const downloadReport =  (refId, docType) => {
  return async (dispatch) => {
    const data = {
      refId: refId,
      docType: docType,
    };

    dispatch(loader(true));

    try {
      const response = await axios({
        method: "post",
        url: `${Config.url}notices/downloadFile`,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
        data: data,
        responseType: "arraybuffer",
      });

      const url = URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", getFileName(docType));
      document.body.appendChild(link);
      link.click();
      link.remove();

      return true;
    } catch (error) {
      console.log("Error in downloadReport:", error);
      errorToastMessage("Error while downloading document");
      return false;
    } finally {
      dispatch(loader(false));
    }
  };
};

export const downloadNotice = (selectedRow) => {
  return async (dispatch) => {
    const refIds = selectedRow?.map((row) => row.refId) || [];

    const data = {
      refIds: refIds,
    };

    dispatch(loader(true));

    try {
      const response = await axios({
        method: "post",
        url: `${Config.url}notices/downloadAll`,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
        data: data,
        responseType: "arraybuffer",
      });

      const url = URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Notices.zip");
      document.body.appendChild(link);
      link.click();
      link.remove();

      return true;
    } catch (error) {
      console.log("Error in downloadNotice:", error);
      errorToastMessage("Error while downloading document");
      return false;
    } finally {
      dispatch(loader(false));
    }
  };
};
